import firebase from '../../api/firebase';
const auth = firebase.auth();
const db = firebase.firestore();
const provider = new firebase.auth.GoogleAuthProvider();

const state = () => ({
  user: JSON.parse(localStorage.getItem('user')) || {},
});

const getters = {
  getUser: (state) => state.user,
  isSignedIn: (state) => state.user.authenticated,
  isPremium: (state) => state.user.premium,
};

const mutations = {
  setUser: (state, user) => {
    state.user = user;
  },
};

const actions = {
  async signIn({ commit }, googleUser) {
    const credentials = provider.credential(
      googleUser.getAuthResponse().id_token
    );

    const response = await firebase
      .auth()
      .signInWithCredential(credentials)
      .catch(function(error) {
        console.log(error);
      });

    const isNewUser = response.additionalUserInfo.isNewUser;

    const userData = {
      displayName: response.user.displayName,
      email: response.user.email,
      photoURL: response.user.photoURL,
      uid: response.user.uid,
    };

    if (isNewUser) {
      await db
        .collection('users')
        .doc(userData.uid)
        .set({ ...userData, premium: false });
    } else {
      await db
        .collection('users')
        .doc(userData.uid)
        .update(userData);
    }

    const userRequest = await db
      .collection('users')
      .doc(userData.uid)
      .get();

    const user = await userRequest.data();

    await localStorage.setItem(
      'user',
      JSON.stringify({ authenticated: true, ...user })
    );
    commit('setUser', { authenticated: true, ...user });
  },
  async signOut({ commit }) {
    auth.signOut();
    const userData = { authenticated: false };
    localStorage.removeItem('user');
    await commit('setUser', userData);
  },
  async fetchUser({ commit }, user) {
    const userRequest = await db
      .collection('users')
      .doc(user.uid)
      .get();
    const userData = await userRequest.data();
    await localStorage.setItem(
      'user',
      JSON.stringify({ authenticated: true, ...userData })
    );
    await commit('setUser', { authenticated: true, ...userData });
  },
  async refreshUser({ dispatch }, user) {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        firebase.auth().currentUser.getIdToken(true);
      }
    });
    if (user.authenticated === true) {
      dispatch('fetchUser', user);
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
